<app-page-header [title]="'Physical Sample Details'"
                 [subtitle]="'View details of the selected physical sample'"></app-page-header>

<!-- Physical Sample Information -->
<h2 class="text-2xl font-semibold mb-2">Physical Sample Information</h2>
<div class="mb-6 border border-gray-300 dark:border-gray-700 p-4 rounded-md">
    <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col gap-1">
            <p><strong>MAC Address:</strong> {{ physicalSample?.macAddress }}</p>
            <p><strong>ID:</strong> {{ physicalSample?.id }}</p>
            <p><strong>Created By:</strong> {{ physicalSample?.createdBy | roleName }}</p>
            <p><strong>Updated By:</strong> {{ physicalSample?.updatedBy | roleName }}</p>
            <p><strong class="mr-2">State:</strong>
                <p-tag
                        [value]="physicalSample?.state | enumLabel"
                        severity="secondary"
                ></p-tag>
            </p>
            <p><strong class="mr-2">Firmware Version:</strong>
                <p-tag
                        [value]="physicalSample?.firmwareVersion ?? 'UNKNOWN'"
                        severity="secondary"
                ></p-tag>
            </p>
            @if (this.rolloutStatusLabel) {
                <p><strong class="mr-2">Rollout Status:</strong>
                    <p-tag
                            [severity]="this.rolloutStatusSeverity"
                            [value]="this.rolloutStatusLabel"
                    ></p-tag>
                </p>
            }
            <p><strong class="mr-2">Hardware Version:</strong>
                <p-tag
                        [value]="physicalSample?.pcb ?? 'UNKNOWN'"
                        severity="secondary"
                ></p-tag>
                @if (this.isPcbRecognized === false) {
                    <span class="ml-2 text-sm text-orange-500 dark:text-orange-300">
                        <i class="pi pi-exclamation-triangle mr-1"></i>Unrecognized hardware revision - check
                        Sample Hardware settings
                    </span>
                }
            </p>
            <p><strong class="mr-2">Battery:</strong>
                <p-tag
                        [value]="physicalSample?.battery ? (physicalSample?.battery | enumLabel) : 'Unknown'"
                        severity="secondary"
                ></p-tag>
            </p>
            <p><strong class="mr-2">Drawer:</strong>
                <p-tag
                        [value]="physicalSample?.inDrawer === null
                                ? 'UNKNOWN' 
                                : (physicalSample?.inDrawer ? 'INSIDE' : 'OUTSIDE')"
                        severity="secondary">
                </p-tag>
            </p>
            <p><strong class="mr-2">Light:</strong>
                <p-tag
                        [value]="physicalSample?.isLightOn === null
                                ? 'UNKNOWN' 
                                : (physicalSample?.isLightOn ? 'ON' : 'OFF')"
                        severity="secondary">
                </p-tag>
            </p>

        </div>
    </div>
</div>

<!-- Owner Dealership Details -->
@if (physicalSample?.ownerDealership) {
    <div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Owner Dealership</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between">
            <div>
                <p><strong>Name:</strong> {{ physicalSample?.ownerDealership?.name }}</p>
                <p><strong>GSSN:</strong> {{ physicalSample?.ownerDealership?.gssn }}</p>
                <p><strong>Country:</strong> {{ physicalSample?.ownerDealership?.country?.name }}</p>
            </div>
            <p-button
                    label="View Dealership"
                    icon="pi pi-eye"
                    routerLink="/dealerships/dealership/{{physicalSample?.ownerDealership?.id}}"
                    outlined
            ></p-button>
        </div>
    </div>
    </div>
}

<!-- Studio Details -->
@if (physicalSample?.studio) {
    <div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Studio</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between">
            <div>
                <p><strong>Name:</strong> {{ physicalSample?.studio?.name }}</p>
                <p><strong>Hostname:</strong> {{ physicalSample?.studio?.hostname }}</p>
                <p><strong class="mr-2">State:</strong>
                    <p-tag
                            [value]="physicalSample?.studio?.state | enumLabel"
                            severity="secondary"
                    ></p-tag>
                </p>
            </div>
            <p-button
                    label="View Studio"
                    icon="pi pi-eye"
                    routerLink="/studios/studio/{{physicalSample?.studio?.id}}"
                    outlined
            ></p-button>
        </div>
    </div>
</div>
}

<!-- Sample Type Details -->
@if (physicalSample?.sample) {
    <div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Sample</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between">
            <div>
                <p><strong>Name:</strong> {{ physicalSample?.sample?.printedName }}</p>
                <p><strong>Category:</strong> {{ physicalSample?.sample?.category?.name ?? 'No category' }}</p>
                <p><strong>Weight:</strong> {{ physicalSample?.sample?.weight + 'g' }}</p>
            </div>
            <p-button
                    label="View Sample"
                    icon="pi pi-eye"
                    routerLink="/samples/sample/{{physicalSample?.sample?.id}}"
                    outlined
            ></p-button>
        </div>
    </div>
    </div>
}

<!-- Action Buttons -->
<div class="flex justify-between items-center mt-6">
    <div class="flex gap-3">
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isProducer label="Edit" severity="secondary"
                  text></p-button>
        <p-button (click)="deletePhysicalSample()" icon="pi pi-trash" isProducer label="Delete" severity="danger"
                  text></p-button>
    </div>
    <p-button label="Back to Physical Samples" icon="pi pi-arrow-left" text routerLink="/physical-samples"></p-button>
</div>

<!-- Update Dialog -->
<app-update-physical-sample-dialog
        [(visible)]="displayUpdateDialog"
        [physicalSample]="editablePhysicalSample"
        (physicalSampleUpdated)="reloadPhysicalSampleDetails()"
></app-update-physical-sample-dialog>
